export const updateSkin=(skinCode)=>{

    return{type:"CHANGE_SKIN" , skinCode : skinCode} 
}